"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _context = require("../context");

// SPDX-License-Identifier: MIT
// Copyright contributors to the kepler.gl project
// @ts-expect-error FeatureFlagsContext is typed as object
var useFeatureFlags = function useFeatureFlags() {
  return (0, _react.useContext)(_context.FeatureFlagsContext);
};

var _default = useFeatureFlags;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2UtZmVhdHVyZS1mbGFncy50c3giXSwibmFtZXMiOlsidXNlRmVhdHVyZUZsYWdzIiwiRmVhdHVyZUZsYWdzQ29udGV4dCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUdBOztBQUNBOztBQUpBO0FBQ0E7QUFVQTtBQUNBLElBQU1BLGVBQWUsR0FBRyxTQUFsQkEsZUFBa0I7QUFBQSxTQUFNLHVCQUF5QkMsNEJBQXpCLENBQU47QUFBQSxDQUF4Qjs7ZUFFZUQsZSIsInNvdXJjZXNDb250ZW50IjpbIi8vIFNQRFgtTGljZW5zZS1JZGVudGlmaWVyOiBNSVRcbi8vIENvcHlyaWdodCBjb250cmlidXRvcnMgdG8gdGhlIGtlcGxlci5nbCBwcm9qZWN0XG5cbmltcG9ydCB7dXNlQ29udGV4dH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHtGZWF0dXJlRmxhZ3NDb250ZXh0fSBmcm9tICcuLi9jb250ZXh0JztcblxudHlwZSBGZWF0dXJlRmxhZ3MgPSB7XG4gIC8vIERlZmluZSB5b3VyIGZlYXR1cmUgZmxhZ3MgaGVyZVxuICBbZmxhZ05hbWU6IHN0cmluZ106IGJvb2xlYW47XG59O1xuXG4vLyBAdHMtZXhwZWN0LWVycm9yIEZlYXR1cmVGbGFnc0NvbnRleHQgaXMgdHlwZWQgYXMgb2JqZWN0XG5jb25zdCB1c2VGZWF0dXJlRmxhZ3MgPSAoKSA9PiB1c2VDb250ZXh0PEZlYXR1cmVGbGFncz4oRmVhdHVyZUZsYWdzQ29udGV4dCk7XG5cbmV4cG9ydCBkZWZhdWx0IHVzZUZlYXR1cmVGbGFncztcbiJdfQ==